
export {SearchOptionsManager};

import {e, jersify} from './utils.js';
import {Actions} from './config.js';
import {state} from './index.js';


// ---------------------------
// SEARCH OPTIONS MANAGER
// ---------------------------

function SearchOptionsManager() {

	// ---------------------------
	// Properties
	// ---------------------------

	var cbPlayers    = [];
	var cbRotations  = [];
	var cbActions    = {};
	if (state.touch) {
		cbActions.touch = [];
		cbActions.attack  = [];
		cbActions.receive  = [];
		cbActions.defend  = [];
		cbActions.set  = [];
		cbActions.faults  = [];
	} else {
		cbActions.in_rally = [];
		cbActions.earned  = [];
		cbActions.errors  = [];
		cbActions.faults  = [];
	}

	var cbAll       = {};
	cbAll.players   = AllPlayersOption(this);

	if (state.touch) {
		cbAll.touch     = AllActionsOption("touch", this);
		cbAll.attack    = AllActionsOption("attack", this);
		cbAll.receive   = AllActionsOption("receive", this);
		cbAll.defend    = AllActionsOption("defend", this);
		cbAll.set       = AllActionsOption("set", this);
		cbAll.faults    = AllActionsOption("faults", this);
	} else {
		cbAll.rotations = AllRotationsOption(this);
		cbAll.in_rally  = AllActionsOption("in_rally", this);
		cbAll.earned    = AllActionsOption("earned", this);
		cbAll.errors    = AllActionsOption("errors", this);
		cbAll.faults    = AllActionsOption("faults", this);
	}

	e("player_head").appendChild(cbAll.players);
	if (state.touch) {
		e("touch_head").appendChild(cbAll.touch);
		e("attack_head").appendChild(cbAll.attack);
		e("receive_head").appendChild(cbAll.receive);
		e("defend_head").appendChild(cbAll.defend);
		e("set_head").appendChild(cbAll.set);
		e("faults_head").appendChild(cbAll.faults);
	} else {
		e("rotation_head").appendChild(cbAll.rotations);
		e("in_rally_head").appendChild(cbAll.in_rally);
		e("earned_head").appendChild(cbAll.earned);
		e("errors_head").appendChild(cbAll.errors);
		e("faults_head").appendChild(cbAll.faults);
	}


	// ---------------------------
	// Functions
	// ---------------------------

	this.load_player_column    = f_load_player_column;
	this.load_rotation_column  = f_load_rotation_column;
	this.load_action_column    = f_load_action_column;

	this.check_all_players     = f_check_all_players;
	this.check_all_rotations   = f_check_all_rotations;
	this.check_all_actions     = f_check_all_actions;

	this.get_checked_players   = f_get_checked_players;
	this.get_checked_rotations = f_get_checked_rotations;
	this.get_checked_actions   = f_get_checked_actions;

	this.all_players_checked   = f_all_players_checked;
	this.all_rotations_checked = f_all_rotations_checked;
	this.all_actions_checked   = f_all_actions_checked;

	this.option_checked        = f_option_checked;


	// ---------------------------
	// Loading Methods
	// ---------------------------

	function f_load_player_column() {

		// Clear the column
		while (e("player_col").children.length > 0) {
			e("player_col").removeChild(e("player_col").firstChild);
		}

		// Get the selected team
		if (e("selTeam").selectedIndex < 0) {
			return;
		}

		// Get the team id
		let team_id = e("selTeam").value;

		// Prepare to capture all players
		let players = [];
		let added   = "";

		// Run through all games
		for (let h = 0; h < state.games.length; h++) {

			let game = state.games[h];

			// Continue if wrong team
			if ((state.touch ? game.teamId : game.team_id) != team_id) {
				continue;
			}

			// Continue if no game log
			if (! game.log) {
				continue;
			}

			// Run through the game log
			for (let i = 0; i < game.log.length; i++) {

				// Get the log item
				let r = game.log[i];

				// Go to next loop if not a log entry
				if (r[0] != "LogEntry") {
					continue;
				}

				// Get the player number
				let player = {};
				player.who  = r[4];
				player.num  = r[5];
				player.name = r[6];

				// See if right team
				if (player.who != "us") {
					continue;
				}

				// See if it's been used already
				if (added.indexOf("{" + player.num + "%" + player.name + "}") >= 0) {
					continue;
				} else {
					added += "{" + player.num + "%" + player.name + "}" + "|";
				}

				// Add the player
				players.push(player);
			}
		}

		// Sort the players
		players.sort(function(a, b) {
			return (parseInt(a.num) > parseInt(b.num)) ? 1 : -1;
		});

		// Add the players to the column
		for (let i = 0; i < players.length; i++) {

			let tile = PlayerSearchOption(players[i].num, players[i].name, this);
			e("player_col").appendChild(tile);
			cbPlayers.push(tile);
		}

		// If the all players or games checkboxes are checked then check all players or games
		if (cbAll.players.checked()) {
			f_check_all_players();
		}
	}

	function f_load_rotation_column() {
		for (let i = 1; i < 7; i++) {
			let tile = RotationSearchOption(i, "Rotation " + i, this);
			e("rotation_col").appendChild(tile);
			cbRotations.push(tile);
		}
	}

	function f_load_action_column(category) {

		for (let i = 0; i < Actions[category].length; i++) {
			let tile = ActionSearchOption(Actions[category][i][0], category, Actions[category][i][1], this);
			e(category + "_col").appendChild(tile);
			cbActions[category].push(tile);
		}
	}


	// ---------------------------
	// Selection Methods
	// ---------------------------

	function f_check_all_players(tf) {
		for (var i = 0; i < cbPlayers.length; i++) {
			cbPlayers[i].check(tf);
		}

		cbAll.players.check(tf);
	}

	function f_check_all_rotations(tf) {
		for (var i = 0; i < cbRotations.length; i++) {
			cbRotations[i].check(tf);
		}

		cbAll.rotations.check(tf);
	}

	function f_check_all_actions(cat, tf) {
		for (var i = 0; i < cbActions[cat].length; i++) {
			cbActions[cat][i].check(tf);
		}

		cbAll[cat].check(tf);
	}


	// ---------------------------
	// Retrieval Methods
	// ---------------------------

	function f_get_checked_players() {
		var checked_players    = [];

		for (var i = 0; i < cbPlayers.length; i++) {
			if (cbPlayers[i].checked()) {
				checked_players.push(cbPlayers[i].eid);
			}
		}

		return checked_players;
	}

	function f_get_checked_rotations() {
		var checked_rotations  = [];

		for (var i = 0; i < cbRotations.length; i++) {
			if (cbRotations[i].checked()) {
				checked_rotations.push(cbRotations[i].eid);
			}
		}

		return checked_rotations;
	}

	function f_get_checked_actions() {
		var checked_actions = {};
		if (state.touch) {
			checked_actions.touch   = [];
			checked_actions.attack  = [];
			checked_actions.receive = [];
			checked_actions.defend  = [];
			checked_actions.set     = [];
			checked_actions.faults  = [];
		} else {
			checked_actions.in_rally = [];
			checked_actions.earned   = [];
			checked_actions.errors   = [];
			checked_actions.faults   = [];
		}

		for (var cat in checked_actions) {
			for (var i = 0; i < cbActions[cat].length; i++) {
				if (cbActions[cat][i].checked()) {
					checked_actions[cat].push(cbActions[cat][i].eid);
				}
			}
		}

		return checked_actions;
	}

	function f_all_players_checked() {
		for (var i = 0; i < cbPlayers.length; i++) {
			if (! cbPlayers[i].checked()) {
				return false;
			}
		}

		return true;
	}

	function f_all_rotations_checked() {
		for (var i = 0; i < cbRotations.length; i++) {
			if (! cbRotations[i].checked()) {
				return false;
			}
		}

		return true;
	}

	function f_all_actions_checked(cat) {
		for (var i = 0; i < cbActions[cat].length; i++) {
			if (! cbActions[cat][i].checked()) {
				return false;
			}
		}

		return true;
	}


	// ---------------------------
	// Events
	// ---------------------------

	function f_option_checked(etype, eid, checked) {
		if (state.touch) {
			if (etype == "checkall") {

				switch (eid) {
					case "players": { f_check_all_players(checked);      break; }
					case "touch":   { f_check_all_actions(eid, checked); break; }
					case "attack":  { f_check_all_actions(eid, checked); break; }
					case "receive": { f_check_all_actions(eid, checked); break; }
					case "defend":  { f_check_all_actions(eid, checked); break; }
					case "set":     { f_check_all_actions(eid, checked); break; }
					case "faults":  { f_check_all_actions(eid, checked); break; }
				}
				return;
			}

			if (checked) {

				switch (etype) {
					case  "player":  { cbAll.players.check(f_all_players_checked());          break; }
					case  "touch":   { cbAll.touch.check(f_all_actions_checked("touch"));     break; }
					case  "attack":  { cbAll.attack.check(f_all_actions_checked("attack"));   break; }
					case  "receive": { cbAll.receive.check(f_all_actions_checked("receive")); break; }
					case  "defend":  { cbAll.defend.check(f_all_actions_checked("defend"));   break; }
					case  "set":     { cbAll.defend.check(f_all_actions_checked("set"));      break; }
					case  "faults":  { cbAll.faults.check(f_all_actions_checked("faults"));   break; }
				}

			} else {

				switch (etype) {
					case "player":  { cbAll.players.check(false); break; }
					case "touch":   { cbAll.touch.check(false);   break; }
					case "attack":  { cbAll.attack.check(false);  break; }
					case "receive": { cbAll.receive.check(false); break; }
					case "defend":  { cbAll.defend.check(false);  break; }
					case "set":     { cbAll.set.check(false);     break; }
					case "faults":  { cbAll.faults.check(false);  break; }
				}
			}

		} else {

			if (etype == "checkall") {

				switch (eid) {
					case "players":   { f_check_all_players(checked);      break; }
					case "rotations": { f_check_all_rotations(checked);    break; }
					case "in_rally":  { f_check_all_actions(eid, checked); break; }
					case "earned":    { f_check_all_actions(eid, checked); break; }
					case "errors":    { f_check_all_actions(eid, checked); break; }
					case "faults":    { f_check_all_actions(eid, checked); break; }
				}
				return;
			}

			if (checked) {

				switch (etype) {
					case "player":   { cbAll.players.check(f_all_players_checked());            break; }
					case "rotation": { cbAll.rotations.check(f_all_rotations_checked());        break; }
					case "in_rally": { cbAll.in_rally.check(f_all_actions_checked("in_rally")); break; }
					case "earned":   { cbAll.earned.check(f_all_actions_checked("earned"));     break; }
					case "errors":   { cbAll.errors.check(f_all_actions_checked("errors"));     break; }
					case "faults":   { cbAll.faults.check(f_all_actions_checked("faults"));     break; }
				}

			} else {

				switch (etype) {
					case "player":   { cbAll.players.check(false);   break; }
					case "rotation": { cbAll.rotations.check(false); break; }
					case "in_rally": { cbAll.in_rally.check(false);  break; }
					case "earned":   { cbAll.earned.check(false);    break; }
					case "errors":   { cbAll.errors.check(false);    break; }
					case "faults":   { cbAll.faults.check(false);    break; }
				}
			}
		}
	}

}


// ---------------------------
// SEARCH OPTION
// ---------------------------

function SearchOption(etype, eid, label, w, listener) {

	var tile          = document.createElement('div');
	tile.className    = "search_option";
	tile.etype        = etype;
	tile.eid          = eid;
	//tile.style.width  = ipx(w);  // now using css instead of w

	var cb            = document.createElement('input');
	cb.type           = "checkbox";
	cb.style.margin   = "0 5px 0 0";

	var lab           = document.createElement('div');
	lab.className     = "search_option_label";
	lab.innerHTML     = label;

	cb.onclick= function() {
		if (listener != undefined) {
			listener.option_checked(etype, eid, this.checked);
		}
	};

	lab.onclick = function() {
		cb.checked = (! cb.checked);
		if (listener != undefined) {
			listener.option_checked(etype, eid, cb.checked);
		}
	};

	tile.checked = function() {
		return cb.checked;
	};

	tile.check = function(tf) {
		cb.checked = (tf == undefined) || (tf == true);
	};

	tile.appendChild(cb);
	tile.appendChild(lab);

	return tile;
}

function PlayerSearchOption(player_id, name, listener)            { return SearchOption("player", player_id, jersify(player_id) + " " + name, 150, listener); }
function RotationSearchOption(num, label, listener)               { return SearchOption("rotation", num, "Rotation " + num,  100, listener); }
function ActionSearchOption(action_id, category, label, listener) { return SearchOption(category, action_id, label, 140, listener); }
function AllPlayersOption(listener)                               { return SearchOption("checkall", "players", "<b>Players</b>", 150, listener); }
function AllRotationsOption(listener)                             { return SearchOption("checkall", "rotations", "<b>Rotations</b>", 100, listener); }
function AllActionsOption(category, listener)                     { return SearchOption("checkall", category, "<b>" + category.substring(0, 1).toUpperCase() + category.substring(1).replace('_', '-') + "</b>", 140, listener); }
